import type { OriginAssets } from "./types";

export const ORIGIN_ASSETS: OriginAssets = {};
